
import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { PedidosService } from 'src/app/services/pedidos.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';

@Component({
    selector: 'app-modal-cadastro-pedidos',
    templateUrl: './modal-cadastro-pedidos.component.html',
    providers: [PedidosService]
})

export class ModalCadastroPedidosComponent implements OnInit {

    modalRef: NgbModalRef;
    public pedido: any;
    public listaEstados = [];

    constructor(
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private appService: AppService,
        private pedidosService: PedidosService,
        private dadosCargasService: DadosCargasService,
    ) {

    }

    popularNovoPedido() {
        this.pedido = {
            nome: '',
            estado: '',
        };
    }

    ngOnInit(): void {
        this.popularNovoPedido();
        this.listaEstados = this.dadosCargasService.mockEstados();
    }

    cadastrar() {
        this.add(this.pedido);
    }

    add(pedido) {
        this.spinner.show();
        this.toastrService.clear();
        this.pedidosService.add(pedido)
            .subscribe(res => {
                this.toastrService.success("Pedido cadastrado.", "Sucesso");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'cadastrado' });
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível cadastrar o pedido!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }
}

